// components/SurveyComponent.js
import React, { useEffect, useState } from "react";
import * as Survey from "survey-react-ui";
import "survey-core/defaultV2.min.css";

const SurveyViewer = ({ surveyConfig }) => {
  const [survey, setSurvey] = useState(null);


  
  useEffect(() => {

    surveyConfig = {
      "title": "Comprehensive Survey with All Components",
      "description": "This survey demonstrates all available question types in survey.js.",
      "pages": [
        {
          "name": "page1",
          "elements": [
            {
              "type": "text",
              "name": "name",
              "title": "What is your name?",
              "isRequired": true
            },
            {
              "type": "comment",
              "name": "feedback",
              "title": "Please provide your feedback."
            },
            {
              "type": "radiogroup",
              "name": "gender",
              "title": "What is your gender?",
              "choices": [
                "Male",
                "Female",
                "Other"
              ],
              "isRequired": true
            },
            {
              "type": "dropdown",
              "name": "country",
              "title": "Select your country",
              "choices": [
                "United States",
                "Canada",
                "United Kingdom",
                "Australia",
                "Other"
              ],
              "isRequired": true
            },
            {
              "type": "checkbox",
              "name": "languages",
              "title": "Which languages do you speak?",
              "choices": [
                "English",
                "Spanish",
                "French",
                "German",
                "Chinese"
              ],
              "isRequired": true
            },
            {
              "type": "rating",
              "name": "satisfaction",
              "title": "How satisfied are you with our service?",
              "minRateDescription": "Not Satisfied",
              "maxRateDescription": "Completely Satisfied",
              "rateMax": 10
            },
            {
              "type": "boolean",
              "name": "recommend",
              "title": "Would you recommend our product?",
              "labelTrue": "Yes",
              "labelFalse": "No"
            },
            {
              "type": "file",
              "name": "resume",
              "title": "Please upload your resume."
            },
            {
              "type": "html",
              "name": "info",
              "html": "<p><b>Thank you</b> for taking this survey!</p>"
            },
            {
              "type": "expression",
              "name": "calculatedAge",
              "title": "Your calculated age",
              "expression": "{currentYear - birthYear}"
            },
            {
              "type": "signaturepad",
              "name": "signature",
              "title": "Please sign here"
            },
            {
              "type": "matrix",
              "name": "experience",
              "title": "Rate your experience with the following aspects:",
              "columns": [
                {
                  "value": 1,
                  "text": "Poor"
                },
                {
                  "value": 2,
                  "text": "Fair"
                },
                {
                  "value": 3,
                  "text": "Good"
                },
                {
                  "value": 4,
                  "text": "Very Good"
                },
                {
                  "value": 5,
                  "text": "Excellent"
                }
              ],
              "rows": [
                {
                  "value": "quality",
                  "text": "Quality"
                },
                {
                  "value": "price",
                  "text": "Price"
                },
                {
                  "value": "usability",
                  "text": "Usability"
                },
                {
                  "value": "design",
                  "text": "Design"
                }
              ]
            },
            {
              "type": "matrixdropdown",
              "name": "performance",
              "title": "Evaluate our services based on the following criteria:",
              "columns": [
                {
                  "name": "efficiency",
                  "title": "Efficiency",
                  "cellType": "rating",
                  "rateMax": 5
                },
                {
                  "name": "reliability",
                  "title": "Reliability",
                  "cellType": "rating",
                  "rateMax": 5
                },
                {
                  "name": "responsiveness",
                  "title": "Responsiveness",
                  "cellType": "rating",
                  "rateMax": 5
                }
              ],
              "rows": [
                {
                  "value": "customerService",
                  "text": "Customer Service"
                },
                {
                  "value": "technicalSupport",
                  "text": "Technical Support"
                },
                {
                  "value": "billingSupport",
                  "text": "Billing Support"
                }
              ]
            },
            {
              "type": "matrixdynamic",
              "name": "skills",
              "title": "Please list your skills and rate your proficiency:",
              "columns": [
                {
                  "name": "skill",
                  "title": "Skill",
                  "cellType": "text"
                },
                {
                  "name": "level",
                  "title": "Proficiency Level",
                  "cellType": "rating",
                  "rateMax": 5
                }
              ],
              "rowCount": 2
            },
            {
              "type": "multipletext",
              "name": "address",
              "title": "Please enter your address",
              "items": [
                {
                  "name": "street",
                  "title": "Street"
                },
                {
                  "name": "city",
                  "title": "City"
                },
                {
                  "name": "zip",
                  "title": "Zip Code"
                }
              ]
            },
            {
              "type": "panel",
              "name": "additionalInfo",
              "title": "Additional Information",
              "elements": [
                {
                  "type": "text",
                  "name": "age",
                  "title": "What is your age?"
                },
                {
                  "type": "dropdown",
                  "name": "education",
                  "title": "What is your highest level of education?",
                  "choices": [
                    "High School",
                    "Associate Degree",
                    "Bachelor's Degree",
                    "Master's Degree",
                    "Doctorate"
                  ]
                }
              ]
            },
            {
              "type": "imagepicker",
              "name": "preferredColor",
              "title": "Choose your preferred color theme:",
              "choices": [
                {
                  "value": "blue",
                  "imageLink": "https://via.placeholder.com/100/0000FF"
                },
                {
                  "value": "green",
                  "imageLink": "https://via.placeholder.com/100/00FF00"
                },
                {
                  "value": "red",
                  "imageLink": "https://via.placeholder.com/100/FF0000"
                }
              ]
            },
            {
              "type": "ranking",
              "name": "preferences",
              "title": "Rank the following options by preference:",
              "choices": [
                "Option 1",
                "Option 2",
                "Option 3",
                "Option 4"
              ]
            },
            {
              "type": "sortablelist",
              "name": "priorityList",
              "title": "Please sort the items in order of importance:",
              "choices": [
                "Quality",
                "Price",
                "Customer Service",
                "Usability",
                "Features"
              ]
            }
          ]
        }
        
       
      ]
    }
      
    if (surveyConfig) {
      const surveyModel = new Survey.Model(surveyConfig);
      setSurvey(surveyModel);
    }
  }, [surveyConfig]);

  const handleSurveyComplete = (sender) => {
    console.log("Survey results:", sender.data);
  };

  if (!survey) return <p>Loading survey...</p>;

  return (
    
    <div className="survey-container mx-auto max-w-xl h-[80vh] p-5 bg-white rounded-lg shadow-md overflow-y-auto">
      <Survey.Survey model={survey} onComplete={handleSurveyComplete} />
    </div>
  );
};

export default SurveyViewer;
